import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import MainPageTextEditor, {
  FormattedMainPageText,
  useMainPageText,
} from "../MainPageTextEditor";
import "./style.css";

const DEFAULT_TEXT = {
  paragraphOne:
    "Testează beneficiile uleiurilor esențiale cu grad terapeutic certificat în ritmul tău.",
  paragraphTwo:
    "Simte transformarea în rutina de zi cu zi — înainte de a lua orice decizie.",
  paragraphThree:
    "Fără presiune. Fără obligații. Doar o conexiune autentică cu starea ta de bine.",
  listLabel: "Ce include experiența ta:",
  itemOne: "Selecție personalizată de 3 uleiuri esențiale",
  itemTwo: "Mini ghid practic cu moduri simple de utilizare",
  itemThree: "Suport pe durata testării mostrelor",
  itemFour: "Acces la rețete și ritualuri exclusive de wellbeing",
};

const TEXT_FIELDS = [
  { key: "paragraphOne", label: "Paragraf 1" },
  { key: "paragraphTwo", label: "Paragraf 2" },
  { key: "paragraphThree", label: "Paragraf 3" },
  { key: "listLabel", label: "Introducere listă" },
  { key: "itemOne", label: "Element listă 1" },
  { key: "itemTwo", label: "Element listă 2" },
  { key: "itemThree", label: "Element listă 3" },
  { key: "itemFour", label: "Element listă 4" },
];

const BloomSamples = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const [content, setContent] = useMainPageText("samples", DEFAULT_TEXT);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="new-samples main-page-text-editable" ref={sectionRef}>
      <MainPageTextEditor
        section="samples"
        sectionLabel="Mostre"
        fields={TEXT_FIELDS}
        value={content}
        onSaved={setContent}
      />
      <div className="new-samples__inner">
        <div className="new-samples__card">
          <div className="new-samples__header">
            <div className={`new-samples__gift-icon ${isVisible ? "new-samples__gift-icon--animate" : ""}`}>
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <rect x="3" y="8" width="18" height="4" rx="1" />
                <rect x="5" y="12" width="14" height="9" rx="1" />
                <line x1="12" y1="8" x2="12" y2="21" />
                <path d="M12 8c-2-4-6-4-6-1s4 1 6 1" />
                <path d="M12 8c2-4 6-4 6-1s-4 1-6 1" />
              </svg>
            </div>

            <span className="new-samples__pre-title">MOSTRE GRATUITE</span>
            <h2 className="new-samples__title">Simte diferența</h2>
            <p className="new-samples__subtitle">înainte să alegi</p>
          </div>

          <div className="new-samples__body">
            <p className="new-samples__desc">
              <FormattedMainPageText text={content.paragraphOne} />
            </p>
            <p className="new-samples__desc">
              <FormattedMainPageText text={content.paragraphTwo} />
            </p>
            <p className="new-samples__desc">
              <FormattedMainPageText text={content.paragraphThree} />
            </p>

            <p className="new-samples__list-title">
              <span aria-hidden="true"></span> <FormattedMainPageText text={content.listLabel} />
            </p>

            <ul className="new-samples__list">
              {/* Premium icon — two droplets */}
              <li className="new-samples__list-item">
                <svg className="new-samples__check" width="20" height="20" viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M11 4C8.2 8.1 5 12.4 5 16a6 6 0 0 0 12 0c0-3.6-3.2-7.9-6-12z" />
                  <path d="M21.5 12c-1.8 2.6-3.5 5.2-3.5 7.5a3.5 3.5 0 0 0 7 0c0-2.3-1.7-4.9-3.5-7.5z" />
                </svg>
                <span><FormattedMainPageText text={content.itemOne} /></span>
              </li>
              {/* 100% Natural icon — leaf */}
              <li className="new-samples__list-item">
                <svg className="new-samples__check" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M17 8C8 10 5.9 16.17 3.82 21.34l1.89.66.95-2.3c.48.17.98.3 1.34.3C19 20 22 3 22 3c-1 2-8 2.25-13 3.25S2 11.5 2 13.5s1.75 3.75 1.75 3.75" />
                </svg>
                <span><FormattedMainPageText text={content.itemTwo} /></span>
              </li>
              {/* Personalizat icon — heart */}
              <li className="new-samples__list-item">
                <svg className="new-samples__check" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                </svg>
                <span><FormattedMainPageText text={content.itemThree} /></span>
              </li>
              {/* Sparkles icon — exclusive rituals */}
              <li className="new-samples__list-item">
                <svg className="new-samples__check" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M12 2l1.5 4.5L18 8l-4.5 1.5L12 14l-1.5-4.5L6 8l4.5-1.5z" />
                  <path d="M19 14l.75 2.25L22 17l-2.25.75L19 20l-.75-2.25L16 17l2.25-.75z" />
                  <path d="M5 17l.5 1.5L7 19l-1.5.5L5 21l-.5-1.5L3 19l1.5-.5z" />
                </svg>
                <span><FormattedMainPageText text={content.itemFour} /></span>
              </li>
            </ul>

          </div>

          <Link to="/evenimente/mostre" className="new-samples__btn">
            Vreau mostre!
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BloomSamples;
